import React from "react";
import LoadingSpinner from "./Spinner/LoadingSpinner";

interface AppContainerProps {
  children: any;
  isLoadingSpinner: boolean;
}

export const AppContainer: React.FC<AppContainerProps> = ({
  children,
  isLoadingSpinner,
}) => {
  return (
    <>
      {children}
      {isLoadingSpinner ? <LoadingSpinner /> : null}
    </>
  );
};

export default AppContainer;
